<template>
    <div>
        <championList :sport_id="sport_id"></championList>
    </div>
</template>

<script>

import championList from '@/components/ballsports/unique_tournament/champion/list.vue';

export default {
    components: {
        championList
    },
    data () {
        let self = (window.x = this)
        return {
            sport_id: 2,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>